module.exports = __webpack_public_path__ + "3bb8cd188e88dfe3b75c26c86dae0d79.svg";


//////////////////
// WEBPACK FOOTER
// C:/Users/Pili/AppData/Roaming/npm/~/pink/css/doge.svg
// module id = 364
// module chunks = 0